module.exports = __webpack_public_path__ + "img/92135.36f92c8c.svg";